var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('div',{staticClass:"header",attrs:{"slot":"header"},slot:"header"},[_c('h3',[_vm._v(_vm._s(_vm.doctor.name))]),_c('p',[_vm._v(_vm._s(_vm.doctor.email))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }